/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

class TvSeriesTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`
    };
  }

  componentDidMount() {

    this.props.tvSeries.id && lh.models.asset.methods.getPosterUrl(this.props.tvSeries, {
      crop: {x: 90, y: 132},
      cache: false
    })
      .then((url) => {
        this.setState({picture: url});
      });
  }

  componentWillReceiveProps(newProps) {

    if (newProps.tvSeries.id !== this.props.tvSeries.id) {
      lh.models.asset.methods.getPosterUrl(newProps.tvSeries, {
        crop: {x: 132, y: 132},
        cache: false
      })
        .then((url) => {
          this.setState({picture: url});
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return _get(this.props, 'tvSeries.id') !== _get(nextProps, 'tvSeries.id')
      || this.state.picture !== nextState.picture
      || this.props.isSelected !== nextState.isSelected
      || !_isEqual(_get(nextProps, 'tvSeries', null), _get(this.props, 'tvSeries', null));
  }

  render() {

    let TvSeriesTileClass = ClassNames({
      'col-last': this.props['col'] === 8,
      'movie block-1 bg-black radius showcase-row-movie-block': true
    });

    let lock = '';
    if (!this.props.tvSeries.is_purchased && !this.props.tvSeries.is_available && !this.props.tvSeries.is_free) {

      lock = <div className="lock">
        <i className="ic ic-lock ic-14px"></i>
      </div>;
    }

    let love = '';
    if (this.props.tvSeries.is_favorite) {
      love = <div className="love">
        <i className="ic ic-fav-in-fill ic-14px"></i>
      </div>;
    }

    return (
      <div className={TvSeriesTileClass} onClick={this.props.onTvSeriesSelect.bind(this, this.props.tvSeries, this.props.row, this.props.col)}>
        <a className="movie-link profile-show col hover">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-14px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}
          <div className="movie-poster">
            <img src={this.state.picture} alt={this.props.tvSeries.title} />
          </div>
          {lock}
          {love}
        </a>
      </div>
    );
  }
}

TvSeriesTile.propTypes = {
  tvSeries: PropTypes.object.isRequired,
  onTvSeriesSelect: PropTypes.func.isRequired
};

export default TvSeriesTile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/TvSeries/tv-series-tile.js